import { useLocation, useNavigate } from 'react-router-dom';
import DataTableWrapper from '../../../Utility/DataTableWrapper/DataTableWrapper';
import { useContext, useEffect, useRef, useState } from 'react';
import { ComuneService } from '../../../../services/ComuneService';
import { UserService } from '../../../../services/UserService';
import ToastContext from '../../../../contexts/toast';
import { FormUtility } from '../../../Utility/FormUtility';
import { useSelector } from 'react-redux';
import { rolesCodes } from '../../../../constants/Roles';
import EnvironmentContext from '../../../../contexts/environment';
import Select from '../../../Form/Select';
import Modal from '../../../Utility/Modal/Modal';

export default function GestioneAnagraficaOperatori() {
  const [dtOptions, setDtOptions] = useState({});
  const navigate = useNavigate();

  const [comune, setComune] = useState(null);
  const [comuni, setComuni] = useState(null);
  const typeOperators = 'asso';

  const [rimozioneData, setRimozioneData] = useState(null);

  const toastContext = useContext(ToastContext);
  const envContext = useContext(EnvironmentContext);

  const roles = useSelector((state) => state.role);

  const utility = new FormUtility({ data: roles });
  const comuneService = new ComuneService();
  const userService = new UserService(envContext);

  const dtRef = useRef();

  const location = useLocation();

  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState(null);
  const [content, setContent] = useState(null);

  useEffect(() => {
    const fetchComuni = async () => {
      const comuniSemplici = await comuneService.getAllByTipologiaAndDenominazioneRegione('Comune', 'Toscana', 'noDismessi');
      const unioni = await comuneService.getAllByTipologiaAndDenominazioneRegione('Unione di Comuni', 'Toscana');
      const gestioniAssociate = await comuneService.getAllByTipologiaAndDenominazioneRegione('Gestione Associata', 'Toscana');
      setComuni([ ...comuniSemplici, ...unioni, ...gestioniAssociate ].sort((a, b) => a.denominazione.localeCompare(b.denominazione)));
    }

    if (utility.checkRoles([rolesCodes.regione])) {
      fetchComuni();
    } else {
      const enteSelezionato = parseInt(roles.enteSelected);
      setComuni([ roles.referenze.find(c => c.id === enteSelezionato) ?? roles.operatori.find(c => c.id === enteSelezionato) ]);
      setComune(roles.referenze.find(c => c.id === enteSelezionato) ?? roles.operatori.find(c => c.id === enteSelezionato));
    }
  }, []);

  const gotoNuovoOperatore = () => {
    navigate('/gestione-anagrafica-operatore' + (roles.enteSelected ? '/' + roles.enteSelected : ''));
  };

  const gotoModificaOperatore = (operatoreId, enteId) => {
    navigate('/gestione-anagrafica-operatore/' + enteId + '/' + operatoreId);
  };

  const rimuoviOperatore = (utenteId, enteId) => {
    setTitle('Rimuovi operatore');
    setContent('Sei sicuro di voler rimuovere questo operatore?');
    setModalOpen(true);
    setRimozioneData({ utenteId, enteId });
  }

  const handleModalAction = () => {
    comuneService.remove(rimozioneData.utenteId, rimozioneData.enteId).then(() => {
      dtRef.current.rerenderDatatable();
      toastContext.success('Operatore disassociato con successo!', 6000);
      setModalOpen(false);
    }).catch(error => {
      toastContext.error(utility.getErrorMsg(error), 12000);
      setModalOpen(false);
    });
  }

  const onChangeEnte = (event) => {
    const value = event.target.value;
    setComune(value ? comuni.find(c => c.id === parseInt(value)) : null);
  }

  useEffect(() => {
    if ((roles.enteSelected && !comune)) {
      return;
    }

    const dtOpt = {
      columns: [
        {
          name: 'Id',
          data: 'id',
          visible: true,
          sortable: false,
          searchable: false
        },
        {
          name: 'Nome',
          data: 'nome',
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: 'Cognome',
          data: 'cognome',
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: 'Codice Fiscale',
          data: 'codiceFiscale',
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: 'Email Istituzionale',
          data: 'emailIstituzionale',
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: 'Telefono Istituzionale',
          data: 'telefonoIstituzionale',
          visible: true,
          sortable: false,
          searchable: true
        },
        {
          name: 'Ente',
          data: 'ente',
          visible: utility.checkRoles([rolesCodes.regione]),
          sortable: true,
          searchable: true,
          cell: (row, col) => (
            <div className='rtds-justify-between rtds-flex'>
              <span className='lg:rtds-hidden rtds-font-semibold'>
                { col.name }
              </span>
              { row.ente }
            </div>
          )
        },
        {
          name: 'Tipologia',
          data: 'tipologia',
          visible: true,
          sortable: true,
          searchable: true
        },
        {
          name: 'Azioni',
          data: null,
          visible: true,
          sortable: false,
          searchable: false,
          center: true,
          cell: (row, col) => (
            <div
              className='rtds-inline-flex rtds-gap-1'
              role='group'
              aria-label='Azioni'
              hidden={row.referenze?.find(el => el.id === comune?.id)}
            >
              <button
                type='button'
                className='rtds-btn--secondary rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => gotoModificaOperatore(row.utenteId, row.enteId)}
                disabled={row.tipologia === 'Referente'}
                title={row.tipologia === 'Referente' ? 'Operazione non disponibile per il referente' : 'Modifica operatore'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--pencil-square`}
                  />
                </svg>
                Modifica
              </button>{' '}
              <button
                type='button'
                className='rtds-btn--danger rtds-btn rtds-btn--s rtds-btn--icon-left rtds-group/button'
                onClick={() => rimuoviOperatore(row.utenteId, roles.enteSelected ?? row.enteId)}
                disabled={row.tipologia === 'Referente'}
                title={row.tipologia === 'Referente' ? 'Operazione non disponibile per il referente' : 'Rimuovi associazione operatore'}
              >
                <svg
                  className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5 group-hover/button:-rtds-translate-x-1'
                  aria-hidden='true'
                  focusable='false'
                  role='img'
                >
                  <use
                    xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--minus-circle`}
                  />
                </svg>
                Rimuovi
              </button>
            </div>
          )
        }
      ],
      serverSide: true,
      ajax: userService.getAllDt,
      ajaxParams: { enteId: typeOperators === 'all' ? null : comune?.id, onlyAssociatedToEnte: typeOperators === 'asso' ? true : typeOperators === 'noAsso' ? false : null },
      rows: [
        /*{ id: 1, title: 'test 123', year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' }*/
      ],
      sorts: [],
      hideSearch: false,
      title: 'Elenco Operatori',
      /*titleSecond: comune && (
        <span className='rtds-content-02'>
          {comune.denominazione +
            (comune.codice
              ? ' (' + comune.denominazioneProvincia + ') Cod. ' + comune.codice
              : '')}
        </span>
      )*/
    };
    setDtOptions(dtOpt);
    loadData();
  }, [comune, typeOperators]);

  const loadData = async () => {
    // let rows= [];
    // for (let i = 1;i<400;i++){
    //     rows.push({ id: i, title: 'test ' + i, year: '2024/25', fasi: ['prima fase', 'seconda fase'], rules: 'Regole relative avviso del 23/24' });
    // }
    // setDtOptions((dtOptions)=> ({...dtOptions,rows}));
  };

  return (
    <>
      <div className='rtds-container rtds-py-6'>
        <div className='rtds-grid rtds-gap-6 xl:rtds-gap-8'>
          <div className='rtds-flex rtds-items-center rtds-justify-between'>
            <h1 className='rtds-heading-2'>{location.pathname === '/gestione-adesione-enti' ? 'Adesione Enti' : location.pathname.startsWith('/gestione-anagrafica-operatori') ? 'Elenco Enti' : 'Operatori comunali'}</h1>
          </div>
        </div>
      </div>

      <DataTableWrapper
        ref={dtRef}
        dtOptions={dtOptions}
        headerButton={
          <div className='rtds-flex rtds-gap-4 align-items rtds-flex-wrap'>
            <Select
              classDiv={'rtds-content-center'}
              classLabel={'rtds-sr-only'}
              label={'Ente'}
              id={'comune'}
              classSelect={''}
              onChange={(event) => onChangeEnte(event)}
              baseOption={'Seleziona Ente'}
              options={comuni}
              bindKey={'id'}
              bindValue={'denominazione'}
              value={comune?.id || ''}
              hidden={roles.enteSelected}
            />

            <button
              type='button'
              className='rtds-btn--primary rtds-btn rtds-btn--icon-left rtds-group/button'
              onClick={() => gotoNuovoOperatore()}
            >
              <svg
                className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                aria-hidden='true'
                focusable='false'
                role='img'
              >
                <use
                  xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--plus-circle`}
                />
              </svg>{' '}
              Inserisci&nbsp;Operatore
            </button>
          </div>
        }
      />

      <Modal
        isOpen={isModalOpen}
        title={title}
        content={content}
        onClose={() => setModalOpen(false)}
        onAction={handleModalAction}
        actionLabel='Conferma'
        closeLabel='Annulla'
      />
    </>
  );
}
